import { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === 'undefined') return 'en';
        return localStorage.getItem('sde_lang') || 'en';
    });

    useEffect(() => {
        const dir = lang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.setAttribute('lang', lang);
        document.documentElement.setAttribute('dir', dir);
        document.body.setAttribute('dir', dir);
        localStorage.setItem('sde_lang', lang);
    }, [lang]);

    const t = useCallback((key, fallback = '') => {
        const dict = translations[lang] || translations.en;
        const value = key.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dict);
        if (value !== undefined) return value;
        // fallback to english
        const enValue = key.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), translations.en);
        return enValue !== undefined ? enValue : fallback || key;
    }, [lang]);

    const toggleLang = useCallback(() => {
        setLang((prev) => (prev === 'en' ? 'ar' : 'en'));
    }, []);

    const value = useMemo(() => ({ lang, setLang, toggleLang, t, dir: lang === 'ar' ? 'rtl' : 'ltr' }), [lang, t, toggleLang]);

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLang must be used within LanguageProvider');
    return ctx;
};
